import axios from '../util/request'
const md5 = require('js-md5')
const stamp = Date.now()

// 新闻列表
export const newsList = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.news_class_id}${stamp}${atob(localStorage.getItem('okey'))}`) 
  return axios.get('/api/xiaosen/user/info/newsList', {
    params: { ...data }
  })
}

// 新闻详情
export const newsInfo = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.id}${stamp}${atob(localStorage.getItem('okey'))}`) 
  return axios.get('/api/xiaosen/user/info/newsInfo', {
    params: { ...data }
  })
}

// 富文本
export const getHtml = (url) => {
  return axios.get(url)
}